export const getBaseUrlFunc = (): string => "https://drs.aobfg.ru/";
